import type { ReactNode } from 'react';

/** Passthrough provider — coordinator store is module-level; mount point for future extensions. */
export function LoadingCoordinatorProvider({ children }: { children: ReactNode }) {
  return children;
}
